var render = function render(){
  var _vm$bindValue;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "column",
    class: _vm.wrapperClass
  }, [_c('b-form-group', {
    class: _vm.labelClass,
    attrs: {
      "id": _vm.filterLabelId,
      "label": _vm.labelIf,
      "label-for": _vm.filterId,
      "label-align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (label) {
        return [_vm.styledLabel ? _c('h2', {
          staticClass: "styled-label"
        }, [_vm._v(_vm._s(_vm.styledLabel))]) : _vm._e(), _vm._v(" "), _vm.hasHovertip ? _c('div', [_vm.hasHovertip ? _c('img', {
          staticClass: "hovertip-help",
          attrs: {
            "id": _vm.getHovertipId,
            "src": _vm.hovertipSrc,
            "alt": "help"
          }
        }) : _vm._e(), _vm._v(" "), _vm.hasHovertip ? _c('b-popover', {
          attrs: {
            "target": _vm.getHovertipId,
            "triggers": "hover focus"
          }
        }, [_c('template', {
          slot: "title"
        }, [_vm._v("\n            " + _vm._s(_vm.getHovertipTitle) + "\n          ")]), _vm._v("\n          " + _vm._s(_vm.getHovertipText) + "\n        ")], 2) : _vm._e()], 1) : _vm._e()];
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "filter-wrapper"
  }, [_c('div', {
    staticClass: "inner-row"
  }, [_c('b-form-input', {
    class: _vm.inputClass + ' form-control mr-sm-5',
    attrs: {
      "id": _vm.filterId,
      "value": _vm.bindValue,
      "type": "text",
      "state": _vm.state,
      "required": _vm.elementRequired,
      "placeholder": _vm.filterPlaceholder,
      "aria-describedby": "input-live-help input-live-feedback"
    },
    on: {
      "input": function ($event) {
        return _vm.updateFilter($event);
      }
    }
  }), _vm._v(" "), ((_vm$bindValue = _vm.bindValue) === null || _vm$bindValue === void 0 ? void 0 : _vm$bindValue.length) > 0 ? _c('filter-clear-button', {
    on: {
      "click": function ($event) {
        return _vm.updateFilter('');
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-form-text', {
    attrs: {
      "id": _vm.filterId + '-help'
    }
  }, [_vm._v("\n      " + _vm._s(_vm.helpText) + "\n    ")])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }